import { useLocation } from 'react-router';
import { Head } from 'zudoku/components';

const SITE_URL = 'https://docs.otonum.io';
const FR_PREFIXES = ['/docs/fr', '/api/fr', '/timeline/fr'];
const NOINDEX_PATHS = ['/example'];

// API sub-routes are generated from translated OpenAPI tags, so only the API roots are paired.
const getAlternates = (pathname: string) => {
  const match = pathname.match(/^\/(docs|timeline)\/(en|fr)(\/.*)?$/);
  if (match) {
    const [, section, , rest = ''] = match;
    return { en: `/${section}/en${rest}`, fr: `/${section}/fr${rest}` };
  }
  if (pathname === '/api/en' || pathname === '/api/fr') {
    return { en: '/api/en', fr: '/api/fr' };
  }
  return undefined;
};

export function SeoHead() {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '') || '/';
  const isFr = FR_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
  const alternates = getAlternates(path);

  return (
    <Head>
      <html lang={isFr ? 'fr' : 'en'} />
      {NOINDEX_PATHS.includes(path) && (
        <meta name="robots" content="noindex, nofollow" />
      )}
      {alternates && (
        <link
          rel="alternate"
          hrefLang="en"
          href={`${SITE_URL}${alternates.en}`}
        />
      )}
      {alternates && (
        <link
          rel="alternate"
          hrefLang="fr"
          href={`${SITE_URL}${alternates.fr}`}
        />
      )}
      {alternates && (
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`${SITE_URL}${alternates.en}`}
        />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Otonum Developer Docs" />
      <meta
        property="og:url"
        content={`${SITE_URL}${path === '/' ? '' : path}`}
      />
      <meta name="twitter:card" content="summary" />
    </Head>
  );
}
